import React from 'react';

// import MapCities from './components/map/map-cities';
import Portfolio from './components/portfolio/portfolio';
import './App.scss';

function App() {

  return (
    <div className="App">
        <Portfolio />
    </div>
  );
}

export default App;
